// extracted by mini-css-extract-plugin
module.exports = {"root":"SuperNavigation_root__YQhpr","list":"SuperNavigation_list__eebzz","link":"SuperNavigation_link__Zqk80","current":"SuperNavigation_current__MQ1l2"};